import React from 'react';
import {
  Dialog,
  Typography,
  Box,
  Stack,
  BoxProps,
  useTheme,
  useMediaQuery,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type TShowProductValueForQuizProps = {
  open: boolean;
  onClose: () => void;
};

const background: BoxProps['sx'] = {
  background: `url(${process.env.PUBLIC_URL}/images/productValue/graphic.png), linear-gradient(103.87deg, #006C9C 7.37%, #002536 100%)`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  borderRadius: '15px',
  padding: '5px',
  position: 'relative',
  margin: '2px',
};

const ProductValueForQuiz: React.FC<TShowProductValueForQuizProps> = ({
  open,
  onClose,
}) => {
  const theme = useTheme();
  const belowMd = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog
      PaperProps={{
        sx: { borderRadius: '15px', maxWidth: '800px', position: 'relative' },
      }}
      open={open}
      onClose={onClose}
    >
      <Box sx={background}>
        <div style={{ margin: '45px' }}>
          <Stack
            alignItems="center"
            justifyContent="space-between"
            direction={belowMd ? 'column' : 'row'}
            gap={belowMd ? 2 : 8}
          >
            <Typography
              variant="subtitle2"
              fontSize={belowMd ? '22px' : '35px'}
              fontWeight={600}
              color="white"
              style={{ whiteSpace: 'pre-line' }}
              textAlign={belowMd ? 'center' : 'left'}
            >
              {"Hey,\nlet's start your\npractice today\n"}
              <span
                style={{
                  fontSize: belowMd ? '11px' : '15px',
                  fontWeight: 'normal',
                }}
              >
                Our Quizzes helps students in
              </span>
            </Typography>
            <img
              src={`${process.env.PUBLIC_URL}/images/productValue/quizvalue.png`}
              alt="header"
              style={
                belowMd
                  ? { width: '160px', height: '210px' }
                  : { width: '250px', height: '300px' }
              }
            />
          </Stack>
        </div>
      </Box>
      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/images/productValue/elipse.png`}
        alt="footercorner"
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100px',
          height: '100px',
        }}
      />
      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/images/productValue/union.png`}
        alt="headercorner"
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: '160px',
          height: '160px',
        }}
      />
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          color: 'white',
          top: 10,
          right: 10,
        }}
      >
        <CloseIcon />
      </IconButton>
    </Dialog>
  );
};

export default ProductValueForQuiz;
